import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FeedbackListComponent } from './feedback-list/feedback-list.component';
import { AuthGuard } from '../shared/auth-guard';
const routes: Routes = [
    { path: 'feedbacklist', component: FeedbackListComponent, canActivate: [AuthGuard] }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FeedbackRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/feedback/feedback-routing.module.ts